<template>
  <div class="px-3 py-3 filter-sidebar">
    <div class="title mb-3">{{ $t('filter-by') }}</div>
    <base-multi-select
      class="mb-3"
      :options="status_options"
      label="trip-status"
      placeholder="search"
      field="status"
      :value="payload.selected_journey_status"
      :small="true"
      @change-value="setValue"
    >
    </base-multi-select>
    <hr />
    <base-input
      name="contractors_contract"
      label="contractors_contract"
      placeholder="contractors_contract"
      type="text"
      field="blanketOrderDescription"
      :value="payload.blanketOrderDescription"
      @change-value="setValue"
      :small="true"
    />
    <base-select
      name="client"
      :label="$t('client')"
      :options="clientOptions"
      field="client"
      :value="payload.client"
      @change-value="onClientChange"
      :small="true"
    />
    <base-input
      name="beneficiary-national-id"
      placeholder="beneficiary-national-id"
      label="beneficiary-national-id"
      type="text"
      field="beneficiaryNationalId"
      :value="payload.beneficiaryNationalId"
      @change-value="setValue"
      :disabled="payload.loading"
      :small="true"
    />
    <base-multi-select
      v-if="showBranchFilter"
      name="branch"
      label="branch"
      :options="$store.getters['enums/branch_enums']"
      placeholder="search"
      field="branch"
      :value="payload.branch"
      :small="true"
      @change-value="setValue"
    />
    <base-select
      name="zone"
      label="zone"
      id="zone"
      :options="$store.getters['enums/zone_enums']"
      field="zone"
      :value="payload.zone"
      @change-value="setValue"
      :small="true"
    />
    <base-multi-select
      name="garage"
      label="garage"
      id="garage"
      :options="localGarageOptions"
      field="garage"
      :value="payload.garage"
      @change-value="setValue"
      :small="true"
    />
    <base-select
      name="water-source"
      label="water-source"
      id="water-source"
      :options="$store.getters['enums/water_source_enums']"
      field="waterSource"
      :value="payload.waterSource"
      @change-value="setValue"
      :small="true"
    />

    <base-input
      name="iqama-number-entry-driver"
      placeholder="iqama-number-entry-driver"
      label="iqama-number-entry-driver"
      type="text"
      field="iqamaNumberEntry"
      :value="payload.iqamaNumberEntry"
      @change-value="setValue"
      :disabled="payload.loading"
      :small="true"
    />
    <base-input
      name="plate-number"
      placeholder="plate-number"
      label="plate-number"
      type="text"
      field="plateNumber"
      :value="payload.plateNumber"
      @change-value="setValue"
      :disabled="payload.loading"
      :small="true"
    />
    <base-input
      name="tanker_number"
      placeholder="tanker_number"
      label="tanker_number"
      type="text"
      field="tgaNumber"
      :value="payload.tgaNumber"
      @change-value="setValue"
      :disabled="payload.loading"
      :small="true"
    />
    <div class="label mb-2 mt-3">{{ $t('trip-from-date') }}</div>
    <div class="row">
      <div class="col-6">
        <div class="sub-label">{{ $t('start-date') }}</div>
        <base-date-time-picker
          :id="start_date_modal_id"
          name="start_date"
          :timePicker="false"
          date_field="start_date"
          :value="payload"
          @change-value="setValue"
        ></base-date-time-picker>
      </div>
      <div class="col-6">
        <div class="sub-label">{{ $t('end-date') }}</div>
        <base-date-time-picker
          :id="end_date_modal_id"
          name="start_date_end"
          :timePicker="false"
          date_field="start_date_end"
          :value="payload"
          :minDate="new Date(payload.start_date)"
          @change-value="setValue"
          :position="isLangRtl ? 'right' : 'left'"
        ></base-date-time-picker>
      </div>
    </div>
    <div class="label mb-2">{{ $t('trip-to-date') }}</div>
    <div class="row">
      <div class="col-6">
        <div class="sub-label">{{ $t('start-date') }}</div>
        <base-date-time-picker
          :id="start_date_modal_id"
          name="end_date"
          :timePicker="false"
          date_field="end_date"
          :value="payload"
          @change-value="setValue"
        ></base-date-time-picker>
      </div>
      <div class="col-6">
        <div class="sub-label">{{ $t('end-date') }}</div>
        <base-date-time-picker
          :id="end_date_modal_id"
          name="end_date_to"
          :timePicker="false"
          date_field="end_date_to"
          :value="payload"
          :minDate="new Date(payload.end_date)"
          @change-value="setValue"
          :position="isLangRtl ? 'right' : 'left'"
        ></base-date-time-picker>
      </div>
    </div>
    <hr />
    <div class="label mb-2">{{ $t('time') }}</div>
    <div class="row">
      <div class="col-6">
        <div class="sub-label">{{ $t('start-time') }}</div>
        <base-time-picker
          field="start_time"
          :value="payload.start_time"
          @change-value="setValue"
          :dropdown_meridiem_picker="true"
          :disabled="!payload.start_date && !payload.start_date_end"
        />
      </div>
      <div class="col-6">
        <div class="sub-label">{{ $t('end-time') }}</div>
        <base-time-picker
          field="end_time"
          :value="payload.end_time"
          @change-value="setValue"
          :dropdown_meridiem_picker="true"
          :disabled="!payload.end_date && !payload.end_date_to"
        />
      </div>
    </div>
    <div>
      <base-button variant="primary" @click="getData" v-b-toggle.sidebar-backdrop>
        {{ $t('filters') }}
      </base-button>
      <div class="reset-link mt-3" v-b-toggle.sidebar-backdrop @click="$emit('reset-data')">
        {{ $t('reset-filters') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    payload: {
      type: Object,
      required: true,
    },
    garageOptions: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['filter-data', 'reset-data'],
  data() {
    return {
      localGarageOptions: this.garageOptions,
      status_options: [
        { text: this.$t('Booking-Confirmed'), value: 'Booking-Confirmed' },
        { text: this.$t('Booking-Re-Assigned'), value: 'Booking-Re-Assigned' },
        { text: this.$t('Booking-Un-Assigned'), value: 'Booking-Un-Assigned' },
        { text: this.$t('Booking-Pending'), value: 'Booking-Pending' },
        { text: this.$t('Booking-Cancelled'), value: 'Booking-Cancelled' },
        {
          text: this.$t('Booking-Cancelled-Note'),
          value: 'Booking-Cancelled-Note',
        },
        { text: this.$t('Trip-Started'), value: 'Trip-Started' },
        {
          text: this.$t('Trip-Arrived-At-Pickup-Location'),
          value: 'Trip-Arrived-At-Pickup-Location',
        },
        // {
        //   text: this.$t("Trip-Passenger-Picked-Up"),
        //   value: "Trip-Passenger-Picked-Up",
        // },
        {
          text: this.$t('Trip-Arrived-To-Dropped-Off'),
          value: 'Trip-Arrived-To-Dropped-Off',
        },
        // {
        //   text: this.$t("Trip-Passenger-Dropped-Off"),
        //   value: "Trip-Passenger-Dropped-Off",
        // },
        { text: this.$t('Trip-Completed'), value: 'Trip-Completed' },
        { text: this.$t('Trip-Completed-Note'), value: 'Trip-Completed-Note' },
      ],
      start_date_modal_id: 'start-date-picker-modal',
      end_date_modal_id: 'end-date-picker-modal',
      start_date_context: {},
      end_date_context: {},
    }
  },
  methods: {
    setValue(val, field) {
      this.payload[field] = val
      this.$emit('update-payload', val, field)

      // if (field === "blanketOrderDescription") {
      //   this.$emit("filter-data");
      // }

      // this.getData();
    },

    onClientChange(val) {
      this.$emit('update-payload', val, 'client')
    },

    async getData() {
      this.$emit('filter-data')
    },
  },
  computed: {
    clientList() {
      return this.$store.getters['clients_list_enums']
    },

    clientOptions() {
      const clients = this.$store.getters['enums/clients_list_enums'] || []

      return clients.map((client) => ({
        text: client.text,
        value: client.value,
        name: client.text,
      }))
    },

    showBranchFilter() {
      const userInfo = this.$store.getters['enums/user_info']

      if (userInfo?.isAssignedToAllBranches) return true

      if (Array.isArray(userInfo?.branch) && userInfo.branch.length > 1) {
        return true
      }

      return false
    },
  },
  mounted() {
    this.$store.dispatch('enums/GET_BRANCH_ENUMS')
    this.$store.dispatch('enums/GET_GARAGE_ENUMS', {}).then(() => {
      this.localGarageOptions = this.$store.getters['enums/garage_enums']
    })
    this.$store.dispatch('enums/GET_ZONE_ENUMS')
    this.$store.dispatch('enums/GET_BLANKET_ORDER_ORDER_CODE_ENUMS')
    this.$store.dispatch('enums/GET_WATER_SOURCE_ENUMS')
    this.$store.dispatch('enums/GET_CLIENT_ENUMS')
  },
}
</script>
